export default __webpack_public_path__ + "static/media/email-sent-blue-xl.e35cefd5.svg";